import * as tslib_1 from "tslib";
import { FluentTheme } from './fluent/FluentTheme';
import { FluentStyles } from './fluent/FluentStyles';
import { addVariants } from '@uifabric/variants';
export var FluentCustomizations = {
  settings: {
    theme: tslib_1.__assign({}, FluentTheme)
  },
  scopedSettings: tslib_1.__assign({}, FluentStyles)
};
addVariants(FluentCustomizations.settings.theme);